/// <amd-module name="Repos/Views/FilesHubActions/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\files-hub-actions\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Get a specific fork sync operation's details.
     * 
     * @param repositoryNameOrId - The name or ID of the repository.
     * @param forkSyncOperationId - OperationId of the sync request.
     * @param project - Project ID or project name
     * @param includeLinks - True to include links.
     */
    getForkSyncRequest(repositoryNameOrId: string, forkSyncOperationId: number, project?: string, includeLinks?: boolean): Promise<Git.GitForkSyncRequest>;
    /**
     * Retrieve all requested fork sync operations on this repository.
     * 
     * @param repositoryNameOrId - The name or ID of the repository.
     * @param project - Project ID or project name
     * @param includeAbandoned - True to include abandoned requests.
     * @param includeLinks - True to include links.
     */
    getForkSyncRequests(repositoryNameOrId: string, project?: string, includeAbandoned?: boolean, includeLinks?: boolean): Promise<Git.GitForkSyncRequest[]>;
    /**
     * Post for retrieving a creating a batch out of a set of items in a repo / project given a list of paths or a long path
     * 
     * @param requestData - Request data attributes: ItemDescriptors, IncludeContentMetadata, LatestProcessedChange, IncludeLinks. ItemDescriptors: Collection of items to fetch, including path, version, and recursion level. IncludeContentMetadata: Whether to include metadata for all items LatestProcessedChange: Whether to include shallow ref to commit that last changed each item. IncludeLinks: Whether to include the _links field on the shallow references.
     * @param repositoryId - The name or ID of the repository
     * @param project - Project ID or project name
     */
    getItemsBatch(requestData: Git.GitItemRequestData, repositoryId: string, project?: string): Promise<Git.GitItem[][]>;
    /**
     * Retrieve all pull requests matching a specified criteria.
     * 
     * @param repositoryId - The repository ID of the pull request's target branch.
     * @param searchCriteria - Pull requests will be returned that match this search criteria.
     * @param project - Project ID or project name
     * @param maxCommentLength - Not used.
     * @param skip - The number of pull requests to ignore. For example, to retrieve results 101-150, set top to 50 and skip to 100.
     * @param top - The number of pull requests to retrieve.
     */
    getPullRequests(repositoryId: string, searchCriteria: Git.GitPullRequestSearchCriteria, project?: string, maxCommentLength?: number, skip?: number, top?: number): Promise<Git.GitPullRequest[]>;
    /**
     * Push changes to the repository.
     * 
     * @param push - 
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     */
    createPush(push: Git.GitPush, repositoryId: string, project?: string): Promise<Git.GitPush>;
    /**
     * Create a git repository in a team project.
     * 
     * @param gitRepositoryToCreate - Specify the repo name, team project and/or parent repository. Team project information can be omitted from gitRepositoryToCreate if the request is project-scoped (i.e., includes project Id).
     * @param project - Project ID or project name
     * @param sourceRef - [optional] Specify the source refs to use while creating a fork repo
     */
    createRepository(gitRepositoryToCreate: Git.GitRepositoryCreateOptions, project?: string, sourceRef?: string): Promise<Git.GitRepository>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get a specific fork sync operation's details.
     * 
     * @param repositoryNameOrId - The name or ID of the repository.
     * @param forkSyncOperationId - OperationId of the sync request.
     * @param project - Project ID or project name
     * @param includeLinks - True to include links.
     */
    public async getForkSyncRequest(
        repositoryNameOrId: string,
        forkSyncOperationId: number,
        project?: string,
        includeLinks?: boolean
        ): Promise<Git.GitForkSyncRequest> {

        const queryValues: any = {
            includeLinks: includeLinks
        };

        return this.beginRequest<Git.GitForkSyncRequest>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryNameOrId}/forkSyncRequests/{forkSyncOperationId}",
            routeValues: {
                project: project,
                repositoryNameOrId: repositoryNameOrId,
                forkSyncOperationId: forkSyncOperationId
            },
            queryParams: queryValues
        });
    }

    /**
     * Retrieve all requested fork sync operations on this repository.
     * 
     * @param repositoryNameOrId - The name or ID of the repository.
     * @param project - Project ID or project name
     * @param includeAbandoned - True to include abandoned requests.
     * @param includeLinks - True to include links.
     */
    public async getForkSyncRequests(
        repositoryNameOrId: string,
        project?: string,
        includeAbandoned?: boolean,
        includeLinks?: boolean
        ): Promise<Git.GitForkSyncRequest[]> {

        const queryValues: any = {
            includeAbandoned: includeAbandoned,
            includeLinks: includeLinks
        };

        return this.beginRequest<Git.GitForkSyncRequest[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryNameOrId}/forkSyncRequests/{forkSyncOperationId}",
            routeValues: {
                project: project,
                repositoryNameOrId: repositoryNameOrId
            },
            queryParams: queryValues
        });
    }

    /**
     * Post for retrieving a creating a batch out of a set of items in a repo / project given a list of paths or a long path
     * 
     * @param requestData - Request data attributes: ItemDescriptors, IncludeContentMetadata, LatestProcessedChange, IncludeLinks. ItemDescriptors: Collection of items to fetch, including path, version, and recursion level. IncludeContentMetadata: Whether to include metadata for all items LatestProcessedChange: Whether to include shallow ref to commit that last changed each item. IncludeLinks: Whether to include the _links field on the shallow references.
     * @param repositoryId - The name or ID of the repository
     * @param project - Project ID or project name
     */
    public async getItemsBatch(
        requestData: Git.GitItemRequestData,
        repositoryId: string,
        project?: string
        ): Promise<Git.GitItem[][]> {

        return this.beginRequest<Git.GitItem[][]>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/ItemsBatch",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            body: requestData
        });
    }

    /**
     * Retrieve all pull requests matching a specified criteria.
     * 
     * @param repositoryId - The repository ID of the pull request's target branch.
     * @param searchCriteria - Pull requests will be returned that match this search criteria.
     * @param project - Project ID or project name
     * @param maxCommentLength - Not used.
     * @param skip - The number of pull requests to ignore. For example, to retrieve results 101-150, set top to 50 and skip to 100.
     * @param top - The number of pull requests to retrieve.
     */
    public async getPullRequests(
        repositoryId: string,
        searchCriteria: Git.GitPullRequestSearchCriteria,
        project?: string,
        maxCommentLength?: number,
        skip?: number,
        top?: number
        ): Promise<Git.GitPullRequest[]> {

        const queryValues: any = {
            searchCriteria: searchCriteria,
            maxCommentLength: maxCommentLength,
            '$skip': skip,
            '$top': top
        };

        return this.beginRequest<Git.GitPullRequest[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/pullRequests/{pullRequestId}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            queryParams: queryValues
        });
    }

    /**
     * Push changes to the repository.
     * 
     * @param push - 
     * @param repositoryId - The name or ID of the repository.
     * @param project - Project ID or project name
     */
    public async createPush(
        push: Git.GitPush,
        repositoryId: string,
        project?: string
        ): Promise<Git.GitPush> {

        return this.beginRequest<Git.GitPush>({
            apiVersion: "5.0-preview.2",
            method: "POST",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/pushes/{pushId}",
            routeValues: {
                project: project,
                repositoryId: repositoryId
            },
            body: push
        });
    }

    /**
     * Create a git repository in a team project.
     * 
     * @param gitRepositoryToCreate - Specify the repo name, team project and/or parent repository. Team project information can be omitted from gitRepositoryToCreate if the request is project-scoped (i.e., includes project Id).
     * @param project - Project ID or project name
     * @param sourceRef - [optional] Specify the source refs to use while creating a fork repo
     */
    public async createRepository(
        gitRepositoryToCreate: Git.GitRepositoryCreateOptions,
        project?: string,
        sourceRef?: string
        ): Promise<Git.GitRepository> {

        const queryValues: any = {
            sourceRef: sourceRef
        };

        return this.beginRequest<Git.GitRepository>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/git/Repositories/{repositoryId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            body: gitRepositoryToCreate
        });
    }

}

export const GitClientName = "Repos.FilesHubActions.Git.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
